<template>
    <div class="text-center">
        <i class="glyphicon glyphicon-refresh glyphicon-spin"></i>
    </div>
</template>

<script>
export default {};
</script>
